import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'SPARE_PART_ARTICLES',
    itemActionName: 'SPARE_PART_ARTICLE',
});
